import { helpers } from '@vuelidate/validators'
;
const LPO_MAX_LENGTH = 80;

export default helpers.withParams(
  { type: 'loanPurposeOtherMaxLength' },
  value => {
    let purposeValid = true;
    if (value) {
      const extraChars = value.match(/[^A-Za-z0-9]/g);
      purposeValid = extraChars && (LPO_MAX_LENGTH >= value.length + extraChars.length);
    } else {
      purposeValid = false;
    }

    return purposeValid;
  }
)
